import { configureStore } from "@reduxjs/toolkit";
import signUpSlice from "./reducers/signUpSlice";
import userInfoSlice from "./reducers/userInfoSlice";
import quesSaveSlice from "./reducers/quesSaveSlice";
import thresholdSlice from "./reducers/thresholdSlice";
import ipAddressSlice from "./reducers/ipAddressSlice";
import resetSlice from "./reducers/resetSlice";
import errorNotifySlice from "./reducers/errorNotifySlice";
import hrinTiggerSlice from "./reducers/hrinTiggerSlice";
import commonSlice from "./reducers/commonSlice";

export const rootReducer = {
	signUp: signUpSlice,
	user: userInfoSlice,
	quesSaveStep: quesSaveSlice,
	thresholdList: thresholdSlice,
	ipAddress: ipAddressSlice,
	apiFail: errorNotifySlice,
	clearStore: resetSlice,
	hrinTigger: hrinTiggerSlice,
	common: commonSlice
};

// Alias restored for CX-50724 (b74d730f renamed persistedReducer -> rootReducer here
// but never updated the ~68 consumers, incl. test.utils.js, that still import it by name).
export const persistedReducer = rootReducer;

export const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.NODE_ENV === "development"
});

export default store;

